<app-mrp-scrolltop></app-mrp-scrolltop>
<!-- Main -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">
      <!-- Elements -->
      <div class="row">
        <div class="col-12 col-12-medium">

          @if (isLoading) {
          <div>
            <div class="spinner-container">
              <div class="spinner"></div>
            </div>
            <h5>Retrieving data...</h5>
          </div>
          }

          @if (!isLoading) {
          <div>
            <h3>{{zoom?.productTitle}}</h3>
            <div class="details-container">
              <div class="item">
                <p><b><u>{{zoom?.location}}</u></b></p>
                <p><b>{{zoom?.eventDate}}</b></p>
                <p>{{zoom?.time}}</p>
                <p>{{ zoom?.amount | currency }}</p>
                <br>
                @if (zoom?.product_descriptions?.length) {
                <div class="class-details">
                  <h5><b>Description</b></h5>
                  @for (desc of zoom?.product_descriptions; track desc) {
                  <p>{{ desc.description }}</p>
                  }
                  <br>
                </div>
                }
                @if (zoom?.topics?.length) {
                <div class="class-details">
                  <h5><b>Topics</b></h5>
                  <ul class="topics-list">
                    @for (topic of zoom?.topics; track topic) {
                    <li>{{ topic.topic }}</li>
                    }
                  </ul>
                </div>
                }
                @if (zoom?.detailedDescription) {
                <div class="class-details">
                  <h5><b>Class Overview</b></h5>
                  <p>{{ zoom?.detailedDescription }}</p>
                </div>
                }
                @if (zoom?.results?.length) {
                <div class="class-details">
                  <h5><b>What You'll Learn</b></h5>
                  <ul class="results-list">
                    @for (result of zoom?.results; track result) {
                    <li>{{ result }}</li>
                    }
                  </ul>
                </div>
                }
                @if (zoom?.coupons?.length) {
                <div class="class-details">
                  <h5><b>$10 Off Coupon</b></h5>
                  @for (coupon of zoom?.coupons; track coupon) {
                  <p>
                    <strong>Code:</strong> {{ coupon.coupon_code }}<br>
                    <strong>Expires:</strong> {{ coupon.coupon_expiration }}
                  </p>
                  }
                  <br>
                  <p><b>Instructions: </b></p>
                  <p>Enter code via the "Add Code" button on the purchase page before expiration date.</p>
                </div>
                }
                <div class="btn-container">
                  <button class="purchase-btn" (click)="initiateCheckout(zoom?.priceID)"
                    [disabled]="isInitiatingCheckout || !zoom?.priceID">
                    @if (!isInitiatingCheckout) {
                    <span>Register</span>
                    }
                    @if (isInitiatingCheckout) {
                    <span class="checkout-spinner"></span>
                    }
                  </button>
                  <span><a (click)="goBack()" class="back-link">Go Back</a></span>
                </div>
              </div>
            </div>
          </div>
          }

        </div>


      </div>
    </div>
  </div>
</section>